
class CartWatcher {
    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }

    async fetchCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    storeCart(cart) {
        localStorage.setItem('nss-cart', JSON.stringify(cart));
    }

    storedCart() {
        return JSON.parse(localStorage.getItem('nss-cart')) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
        const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
        let result = {
            added: onlyInLeft(newCart.items, oldCart.items),
            removed: onlyInLeft(oldCart.items, newCart.items),
        };

        oldCart.items.forEach(oi => {
            const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
            if (!ni) return;
            let quantity = ni.quantity - oi.quantity;
            let item = { ...ni };
            item.quantity = Math.abs(quantity);
            quantity > 0
                ? result.added.push(item)
                : result.removed.push(item)
        });

        return result;
    }

    async emitCartChanges() {
        const newCart = await this.fetchCart();
        const oldCart = this.storedCart();
        const changes = this.findCartChanges(oldCart, newCart);

        const event = new CustomEvent("cart_changed", { detail: changes });
        window.dispatchEvent(event);

        this.storeCart(newCart);
    }

    observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);
                if (isValidRequestType && isCartChangeRequest) {
                    this.emitCartChanges();
                }
            });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
    }
}

function setStorageWithExpiry(key, value, days) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + (1 * days));
    const item = {
        value: value,
        expiry: expiryDate.getTime(),
    }
    localStorage.setItem(key, JSON.stringify(item));
}
function getStorageWithExpiry(key) {
    const itemVal = localStorage.getItem(key);
    if (!itemVal) return null;
    const item = JSON.parse(itemVal);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

function closeUpsell(upsell) {
    upsell.classList.remove('is--visible');
    upsell.setAttribute('aria-hidden', true);
}
    
function closeUpsellStore(upsell) {
    closeUpsell(upsell);
    setStorageWithExpiry('nss-global-upsell-status', 'closed', 1);
}

function initGlobalUpsell() {
    const globalUpsells = document.querySelectorAll(
        '[nss-global-upsell]',
    );
    [...globalUpsells].forEach(globalUpsell => {
        const closeButtons = globalUpsell.querySelectorAll('[js-close]');
        const atcButtons = globalUpsell.querySelectorAll('[js-atc]');
        const targetProductID = atcButtons[0]?.getAttribute('data-product') || '';
        window.addEventListener('cart_changed', e => {
            if (targetProductID != '') {
                const status = getStorageWithExpiry('nss-global-upsell-status');
                if (status == 'closed') return;
                const addedProducts = e?.detail?.added || [];
                const filteredProducts = addedProducts.filter(product => product.id != targetProductID);
                const excludedPaths = ['/products/stur-10ct-vrty'];
                if (filteredProducts.length > 0 && !excludedPaths.includes(window.location.pathname)) {
                    globalUpsell.classList.add('is--visible');
                    globalUpsell.setAttribute('aria-hidden', false);
                }
            }
        });

        closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', () => {
                if (closeButton.hasAttribute('js-close-save')) {
                    closeUpsellStore(globalUpsell)
                } else {
                    closeUpsell(globalUpsell);
                }
            });
        });

        atcButtons.forEach(atcButton => {
            atcButton.addEventListener('click', (e) => {
                e.preventDefault();
                const productID = atcButton.getAttribute('data-product');
                if (productID) {
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            'items': [
                                {
                                    'id': productID,
                                    'quantity': 1
                                }
                            ]
                        })
                    }).then(r => {
                        return r.json();
                    }).then(response => {
                        closeUpsellStore(globalUpsell);
                        if (typeof window.NSS_REFRESH_AND_OPEN_CART === `function`) window.NSS_REFRESH_AND_OPEN_CART();
                    });
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', event => {
    new CartWatcher().init();
    initGlobalUpsell();
});
